import { render } from "./ConsultationPatientQueueModal.vue?vue&type=template&id=fac8a3c8"
import script from "./ConsultationPatientQueueModal.vue?vue&type=script&lang=js"
export * from "./ConsultationPatientQueueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__